import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-filter-container',
  templateUrl: './filter-container.component.html',
  styleUrl: './filter-container.component.scss',
  animations: [
    trigger('accordion', [
      state('open', style({
        maxHeight: '800px',
        opacity: 1,
      })),
      state('closed', style({
        maxHeight: '0',
        opacity: 0,
      })),
      transition('open <=> closed', [
        animate('0.35s ease')
      ]),
    ]),
  ],
})
export class FilterContainerComponent implements OnChanges {

  @Input() header: boolean = true;
  @Input() closeButton: boolean = true;
  @Input() miniCloseButton: boolean = false;
  @Input() show: boolean = false;
  @Input() placeholder: string = '';
  @Input() showIcon: boolean = true;
  @Input() positionRight: boolean = false;
  @ViewChild('contentRef') contentRef!: ElementRef;
  @Output() closeOn = new EventEmitter<void>();
  contentHeight: number = 0;

  constructor() {
  }


  ngOnChanges() {
    console.warn()
  }

  close() {
    this.closeOn.emit()
  }

}
